import { DialogBody as FluentDialogBody } from "@fluentui/web-components";
/**
 * DialogBody
 * @summary Dialog Body component that extends the FASTElement class, providing slots for title, title-action, content, and actions.
 *
 * @example
 * ```html
 * <fabric-dialog-body no-title-action="false">
 *   <span slot="title">Title</span>
 *   <span slot="title-action">Action</span>
 *   <div>Content of the dialog body</div>
 *   <span slot="action">Action buttons</span>
 * </fabric-dialog-body>
 * ```
 *
 * @attr {boolean} no-title-action - Indicates if the title action should be displayed.
 *
 * @prop {boolean} noTitleAction - Indicates whether the dialog has a title action.
 *
 * @slot title - Slot for the dialog title.
 * @slot title-action - Slot for the dialog title action, typically a close button.
 * @slot - The default slot for dialog content.
 * @slot action - Slot for dialog actions, such as buttons.
 *
 * @csspart title - The dialog title container.
 * @csspart content - The dialog content container.
 * @csspart actions - The dialog actions container.
 * @csspart title-action - The dialog title action container.
 *
 * @extends FluentDialogBody
 * @tagname fabric-dialog-body
 * @public
 */
export class DialogBody extends FluentDialogBody {
}
//# sourceMappingURL=dialog-body.js.map